import React from "react";

const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_newman-justice-fund/artifacts/lc0m8u1i_ChatGPT%20Image%20May%2023%2C%202026%2C%2010_38_23%20AM.png";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100vh] w-full overflow-hidden"
    >
      {/* Background image */}
      <img
        src={HERO_IMAGE}
        alt=""
        aria-hidden="true"
        fetchpriority="high"
        decoding="async"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />

      {/* Gradient overlays */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#091A33] via-[#091A33]/85 md:via-[#091A33]/70 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0F2240] via-transparent to-[#0F2240]/40" />

      {/* Grain */}
      <div className="grain absolute inset-0" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 lg:px-16 pt-36 md:pt-40 pb-16 md:pb-24 min-h-[100vh] flex flex-col justify-center">
        <div className="max-w-2xl">
          {/* Eyebrow */}
          <div className="flex items-center gap-4 mb-6 md:mb-8">
            <div className="h-px w-10 bg-[#B89968]" />
            <span className="text-[#B89968] text-xs md:text-sm uppercase tracking-[0.32em] font-medium">
              Auto Accident Attorneys
            </span>
          </div>

          {/* Headline */}
          <h1
            data-testid="hero-headline"
            className="font-serif-display text-white text-[2.5rem] sm:text-5xl lg:text-[4.25rem] leading-[1.05] tracking-tight font-medium"
          >
            When Life Changes
            <br className="hidden sm:block" /> in an{" "}
            <span className="italic gold-text">Instant</span>,
            <br className="hidden sm:block" /> We're Here to Help.
          </h1>

          {/* Sub */}
          <p
            data-testid="hero-subtext"
            className="mt-6 md:mt-8 text-lg md:text-xl text-[#CBD5E1] max-w-xl leading-relaxed"
          >
            If you were injured in an auto accident, Newman Injury Law is here to
            help protect everything you've built. Personal, dedicated
            representation — no fee unless we win.
          </p>

          {/* CTAs */}
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <button
              data-testid="hero-cta-primary"
              onClick={() => scrollTo("lead-form")}
              className="group inline-flex items-center justify-center gap-3 bg-[#B89968] text-[#0F2240] px-8 py-4 font-semibold uppercase tracking-[0.18em] text-sm hover:bg-[#CFB079] transition-colors duration-300"
            >
              Get Help Now
              <span className="inline-block transition-transform group-hover:translate-x-1">
                →
              </span>
            </button>
            <button
              data-testid="hero-cta-secondary"
              onClick={() => scrollTo("lead-form")}
              className="inline-flex items-center justify-center px-8 py-4 border border-[#B89968]/70 text-white hover:bg-[#B89968]/10 hover:border-[#B89968] transition-colors duration-300 uppercase tracking-[0.18em] text-sm"
            >
              Free Consultation
            </button>
          </div>

          {/* Trust pills */}
          <div className="mt-12 flex flex-wrap gap-x-8 gap-y-3 text-sm text-[#94A3B8]">
            <div className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-[#B89968]" />
              No Fee Unless We Win
            </div>
            <div className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-[#B89968]" />
              Available 24/7
            </div>
            <div className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-[#B89968]" />
              Millions Recovered
            </div>
          </div>
        </div>
      </div>

      {/* Bottom subtle scroll cue */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 hidden md:flex flex-col items-center gap-2 text-[#94A3B8] text-xs uppercase tracking-[0.3em]">
        <span>Scroll</span>
        <div className="w-px h-12 bg-gradient-to-b from-[#B89968] to-transparent" />
      </div>
    </section>
  );
}
